import { render, staticRenderFns } from "./XDumbPagination.vue?vue&type=template&id=78bea0ec"
import script from "./XDumbPagination.vue?vue&type=script&lang=js"
export * from "./XDumbPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports